var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-empty-state",class:{ 'market-empty-state--small': _vm.small }},[_c('div',{staticClass:"market-empty-state__icon-circle"},[_c('img',{staticClass:"market-empty-state__icon",attrs:{"src":_vm.iconSrc,"alt":_vm.icon}})]),_vm._v(" "),_c('div',{staticClass:"market-empty-state__content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64e2bcbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/market-empty-state/market-empty-state.vue
// module id = FBuH
// module chunks = 0